import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var ieMq = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)'; // IE11 only
  var mobileMq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ") and (-ms-high-contrast: active), screen and (").concat(componentTheme.phoneBreakPoint, ") and (-ms-high-contrast: none)");
  return {
    popoverHeaderBox: {
      borderBottom: "solid ".concat(componentTheme.popoverHeaderBoxBorderWidth, " ").concat(componentTheme.popoverHeaderBoxBorderColor)
    },
    popoverHeader: {
      margin: '1rem',
      marginBottom: '0.25rem'
    },
    popoverContent: _defineProperty(_defineProperty({
      marginLeft: componentTheme.popoverContentMargin,
      marginRight: componentTheme.popoverContentMargin
    }, ieMq, {
      width: '22rem'
    }), mobileMq, {
      width: '11rem'
    })
  };
};
export default generateStyle;